import { Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import styles from './loadingIndicator.module.scss'

interface LoadingIndicatorProps {
  message: string
  messageStyle?: React.CSSProperties
  subMessage?: string
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = props => {
  const { message, messageStyle, subMessage } = props
  const sub = subMessage ? <h6>{`${subMessage}`}</h6> : null
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingIndicator}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>
      <Spacer space="x3" />
      <div style={messageStyle} css={{ width: '100%' }}>
        <Text
          type="title"
          color="primaryBody"
          alignment="center"
          weight="regular"
        >
          {`${message}`}
        </Text>
      </div>
      {sub}
    </div>
  )
}

export default LoadingIndicator
